const IMAGES = {
  logoPoitiers: new URL("./logo-sinem-poitiers.png", import.meta.url).href,
  logoSaintes: new URL("./logo-sinem-saintes.png", import.meta.url).href,
};

export default IMAGES;
